const API_BASE = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') || (typeof window !== 'undefined' ? window.location.origin : '')

/**
 * Resolves an image URL for display.
 * - Already absolute (http/https) → returned as-is (works for GCP CDN and local)
 * - Relative path (/media/...) → prepends API base for local dev
 * - Null/empty → returns null
 */
export function resolveImageUrl(url) {
  if (!url) return null
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  return `${API_BASE}${url.startsWith('/') ? '' : '/'}${url}`
}
